const formatTime = (seconds: number): string => {
  const minutes = Math.floor(seconds / 60);
  const remainSeconds = seconds % 60;

  function padTo2Digits(num: number) {
    return num.toString().padStart(2, '0');
  }

  return `${minutes}:${padTo2Digits(remainSeconds)}`;
};

export { formatTime };
